import React from "react";
import { TypeAnimation } from "react-type-animation";
import imagePath from "../Images/programmer.svg";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function Intro() {
  const { language } = useLanguage();
  const t = translations[language];

  const handleClick = () => {
    window.location.href = "mailto:josuerushanika@gmail.com";
  };

  const { elementRef, isVisible } = useRevealOnScroll();

  const roleSequence = t.intro.roles.flatMap((role) => [role, 1500]);

  return (
    <section
      ref={elementRef}
      className={`intro-container relative overflow-hidden px-6 py-20 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-32 left-1/4 h-80 w-80 rounded-full bg-coding-color/10 blur-3xl" />
        <div className="absolute -bottom-24 right-1/4 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
      </div>
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-12 md:flex-row">
        <div className="order-2 w-full md:order-1 md:w-1/2">
          <p className="text-sm font-coding-font text-coding-color">
            {t.intro.greeting}
          </p>
          <h1 className="dev-name pt-4 font-main-font text-4xl font-bold text-gray-light sm:text-5xl lg:text-6xl">
            {t.intro.name}
          </h1>
          <h2 className="dev-animation pt-3 font-main-font text-2xl text-header-color sm:text-3xl lg:text-4xl">
            <TypeAnimation
              sequence={roleSequence}
              wrapper="span"
              cursor
              repeat={Infinity}
            />
          </h2>

          <p className="pt-6 text-base text-gray-light md:text-lg md:leading-relaxed">
            {t.intro.paragraph1}
          </p>
          <p className="pt-4 text-base text-gray-light md:text-lg md:leading-relaxed">
            {t.intro.paragraph2}
          </p>

          <div className="intro-buttons mt-8 flex flex-wrap gap-4 text-gray-light">
            <button
              onClick={handleClick}
              className="rounded bg-gray-800 px-6 py-2 text-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:scale-105 hover:bg-gray-700 hover:text-white focus:outline-none"
            >
              {t.intro.hireMe}
            </button>
            <a
              href="#projects"
              className="rounded bg-gray-800 px-6 py-2 text-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:scale-105 hover:bg-gray-700 hover:text-white focus:outline-none"
            >
              {t.intro.seeProjects}
            </a>
          </div>
        </div>

        <div className="order-1 flex w-full justify-center md:order-2 md:w-1/2">
          <div className="illustration max-w-xs md:max-w-sm animate-float-slow">
            <img
              src={imagePath}
              alt="Developer at a computer"
              width={786}
              height={572}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
